export enum EOrgUserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  EXPIRED = "EXPIRED",
  NO_ACCESS = "NO_ACCESS",
  INVITED = "INVITED",
}
